import * as React from 'react';
import { useEffect } from 'react';
import { useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';

function migrateLegacyHeroEvents(events) {
  if (!events || typeof events !== 'object') return [];

  return Object.keys(events)
    .filter((key) => /^event\d+$/.test(key))
    .sort(
      (a, b) =>
        Number(a.replace('event', '')) - Number(b.replace('event', '')),
    )
    .map((key) => {
      const entry = events[key];
      if (!entry || typeof entry !== 'object') return null;
      return {
        eventId: entry.eventId ?? entry.id ?? null,
        groupid: entry.groupid ?? null,
        featuredImage: entry.featuredImage ?? null,
      };
    })
    .filter((entry) => entry && (entry.eventId || entry.groupid));
}

function normalizeSpecialEvents(entries) {
  if (!Array.isArray(entries)) return [];
  return entries
    .filter((entry) => entry && typeof entry === 'object')
    .map((entry) => ({
      eventId: entry.eventId ?? entry.id ?? null,
      groupid: entry.groupid ?? null,
      featuredImage: entry.featuredImage ?? null,
    }));
}

/** Eski event1..event8 → specialEvents; useInput kullanmaz (ArrayInput ile cakismasin). */
export function HeroLegacyMigrator() {
  const record = useRecordContext();
  const { setValue, getValues } = useFormContext();

  useEffect(() => {
    if (!record?.id) return;

    const current = getValues('specialEvents');
    if (Array.isArray(current)) {
      const cleaned = normalizeSpecialEvents(current);
      const hasGarbage = current.some(
        (entry) => !entry || typeof entry !== 'object',
      );
      if (hasGarbage || JSON.stringify(cleaned) !== JSON.stringify(current)) {
        setValue('specialEvents', cleaned, { shouldDirty: false });
      }
      if (cleaned.length > 0) return;
    }

    const migrated = migrateLegacyHeroEvents(record.events);
    if (migrated.length) {
      setValue('specialEvents', migrated, { shouldDirty: false });
    }
  }, [record?.id]);

  return null;
}

export { migrateLegacyHeroEvents, normalizeSpecialEvents };
